import { memo } from 'react'
import { CheckCircle } from 'lucide-react'
import { getStyleImageUrl, type StyleSummary } from '@ponpon/api-client'

interface StyleCreatorSuccessProps {
  style: StyleSummary
  onUseStyle: (styleId: string) => void
  onBack: () => void
}

const StyleCreatorSuccess = memo(({ style, onUseStyle }: StyleCreatorSuccessProps) => (
  <div className="flex flex-col items-center gap-6 py-8 px-6">
    <div className="flex flex-col items-center gap-3">
      <CheckCircle className="w-12 h-12 text-green-500" />
      <p className="text-lg font-semibold text-foreground">
        &ldquo;{style.name}&rdquo; created!
      </p>
    </div>

    <div className="flex items-center justify-center gap-3">
      {style.thumbnail_url ? (
        <img
          src={getStyleImageUrl(style.thumbnail_url)}
          alt={`${style.name} thumbnail`}
          className="w-40 h-40 rounded-lg object-cover border border-white/10 flex-shrink-0"
          onError={(e) => {
            e.currentTarget.style.display = 'none'
          }}
        />
      ) : (
        <div className="w-40 h-40 rounded-lg bg-gradient-to-br from-white/10 to-white/5 flex items-center justify-center border border-white/10 flex-shrink-0">
          <span className="text-foreground/20 text-3xl font-bold">
            {style.name[0]}
          </span>
        </div>
      )}

      {style.preview_image_urls.slice(0, 3).map((url, i) => (
        <img
          key={i}
          src={getStyleImageUrl(url)}
          alt={`${style.name} preview ${i + 1}`}
          className="w-28 h-28 rounded-lg object-cover border border-white/10 flex-shrink-0"
          onError={(e) => {
            e.currentTarget.style.display = 'none'
          }}
        />
      ))}
    </div>

    <button
      onClick={() => onUseStyle(style.id)}
      className="bg-pink-500 hover:bg-pink-600 text-white font-medium py-2.5 px-6 rounded-lg transition-colors"
      data-testid="style-creator-use-this-style-btn"
    >
      Use This Style
    </button>
  </div>
))

StyleCreatorSuccess.displayName = 'StyleCreatorSuccess'
export { StyleCreatorSuccess }
